import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import leaf from "../../Assets/Projects/leaf.png";
import glob from "../../Assets/Projects/Globbbb.PNG";
import emotion from "../../Assets/Projects/emotion.jpeg";
import editor from "../../Assets/Projects/codeEditor.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";
import resumeBuilder from "../../Assets/Projects/resumeBuilder.PNG";
import dynamic from "../../Assets/Projects/dynamic.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={resumeBuilder}
              isBlog={false}
              title="Resume builder"
              description="Resume Builder - build with react.js, Node.js.
               Have features which allows user to fill their informations and to download their Cv after that with PDF format."
              link=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={glob}
              isBlog={false}
              title="THIINK-AIR"
              description="Notre solution permet de surveiller la qualité de l'air intérieur (QAI), permettant la mesure en temps réel de plusieurs paramètres principaux pour surveiller la qualité de l'air intérieur à différents points du bâtiment, tels que la température, l'humidité relative  et le taux de CO2 (En ppm). Les niveaux de température, d'humidité et de dioxyde de carbone (CO2) sont mesurés par des capteurs IoT spécifiques."
              link=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Editor.io"
              description="Online code and markdown editor build with react.js. Online Editor which supports html, css, and js code with instant view of website. Online markdown editor for building README file which supports GFM, Custom Html tags with toolbar and instant preview.Both the editor supports auto save of work using Local Storage"
              link=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Back-Office"
              description="this project helped administrator to manage their resources in the entreprise , build with react.js redux , node.js,JWT,Postgresql."
              link=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dynamic}
              isBlog={false}
              title="Dynamic web Content"
              description="this project is build with Angular , SpringBoot and mySql."
              link=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              link=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
